import "./index.scss";

const DefaultCellRenderer = (props) => {
  props.reactContainer.classList.add("cell-container");
  return props.value;
};

export default DefaultCellRenderer;
